import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conditionFunction',
})
export class ConditionFunctionPipe implements PipeTransform {
  transform<T>(row: T, conditionFn?: (row: T) => boolean): boolean {
    return conditionFn ? conditionFn(row) : false;
  }
}
